import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/widgets/Chronicle/components/ChronicleIntroSection/ChronicleIntroSection.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/widgets/Chronicle/Chronicle.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ChronicleTimeline"] */ "/var/www/light_of_empire_front/widgets/Chronicle/components/ChronicleTimeline/ChronicleTimeline.tsx");
